// extracted by mini-css-extract-plugin
export var alignCenter = "_5n-d";
export var bannerShown = "_5n-6";
export var buttonContent = "_5n-0";
export var cardList = "_5n-1";
export var centerContent = "_5n-2";
export var chevron = "_5n-3";
export var closePanelButton = "_5n-k";
export var conversationContextContainer = "_5n-l";
export var conversationDetailContainer = "_5n-4";
export var detailWrapper = "_5n-7";
export var dropdownButton = "_5n-e";
export var dropdownTitle = "_5n-9";
export var fullHeight = "_5n-5";
export var hidden = "_5n-a";
export var icon = "_5n-b";
export var mergeSuggestionWrapper = "_5n-m";
export var panel = "_5n-i";
export var portalButtonsWrapper = "_5n-c";
export var right = "_5n-j";
export var tableSummaryContainer = "_5n-8";
export var tableSummaryHeader = "_5n-g";
export var threeDotsButton = "_5n-f";
export var wide = "_5n-h";